<script>
    import { onMount, tick, createEventDispatcher } from "svelte";

    import Loader from "../components/Loader.svelte";
    import CollectionEntry from "../components/CollectionEntry.svelte";
    import SubscriptionMessage from "../components/SubscriptionMessage.svelte";

    import { recentlyAddedItems, currentLocation } from "../stores.js";

    onMount(() => {
        currentLocation.set("recently-added");
    });

    const music = MusicKit.getInstance();

    const dispatch = createEventDispatcher();

    let isLoading = false;
    let hasEnded = false;

    let target;

    onMount(() => {
        maybeLoadMore();
    });

    async function loadMore() {
        if (hasEnded == true || isLoading == true) return;
        try {
            isLoading = true;
            const { data: { data: entries } } = await music.api.music("/v1/me/library/recently-added", {
                offset: $recentlyAddedItems.cursor,
            });
            if (entries.length == 0) {
                hasEnded = true;
                return;
            }
            recentlyAddedItems.update(({ items, cursor }) => {
                const distinct = entries.filter(it => !items.some(el => it.id === el.id));
                items.push(...distinct);
                cursor += entries.length;
                return { items, cursor };
            });
        } catch (err) {
        } finally {
            isLoading = false;
        }
        await tick();
        maybeLoadMore();
    }

    async function maybeLoadMore() {
        const shouldLoadMore =
            isLoading == false && hasEnded == false && target != undefined;
        if (shouldLoadMore) {
            const scrollTop = target.scrollTop;
            const scrollHeight = target.scrollHeight;
            const clientHeight = target.clientHeight;
            if (
                $recentlyAddedItems.cursor == 0 ||
                scrollTop >= scrollHeight - clientHeight * 1.5
            ) {
                loadMore();
            }
        }
    }

    function handleItemClick(item) {
        return function () {
            dispatch("open-modal", item);
        };
    }

    function handleItemContextMenu(item) {
        return function (event) {
            const { pageX, pageY, target } = event.detail;
            dispatch("context-menu", { item, pageX, pageY, target });
        };
    }
</script>

{#if music.isAuthorized}
    <div class="scroll" bind:this={target} on:scroll={() => maybeLoadMore()}>
        {#if $recentlyAddedItems.cursor > 0}
            <div class="grid">
                {#each $recentlyAddedItems.items as item (item.id)}
                    <CollectionEntry
                        {item}
                        on:click={handleItemClick(item)}
                        on:context-menu={handleItemContextMenu(item)}
                    />
                {/each}
                {#if isLoading && !hasEnded}
                    <div class="inline-loader">
                        <Loader />
                    </div>
                {/if}
            </div>
        {:else}
            <div class="message">
                <Loader />
            </div>
        {/if}
    </div>
{:else}
    <SubscriptionMessage />
{/if}

<style>
    :host {
        position: relative;
        color: #fff;
        background-color: #232323;
    }

    .scroll {
        width: 100%;
        height: 100%;
        overflow: auto;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-color: #444 #171717;
    }

    .grid {
        display: grid;
        grid-gap: 10px;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        padding: 10px;
        box-sizing: border-box;
    }

    .message {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 100%;
        height: 100%;
        font-size: 25px;
        font-weight: bold;
    }

    .inline-loader {
        width: 150px;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
